import * as React from 'react';
import styles from './styles.module.scss';
import ActiveLink from '@/components/ui/ActiveLink';
import Scroller from '@/components/ui/Scroller';

export type ITabItem = {
  key?: string | number;
  label: string;
  onClick?: () => void;
  href: string;
  exact?: boolean;
};

export interface ITabsProps {
  items: ITabItem[];
}

const Tabs: React.FunctionComponent<ITabsProps> = (props) => {
  return (
    <div className={styles['tabs']}>
      <Scroller
        showArrows={false}
        showDots={false}
        showScrollbar={false}
      >
        <ul className={styles['tabs__list']}>
          {props.items.map((item, itemIndex) => {
            return (
              <li key={item.key ? item.key : itemIndex}>
                <ActiveLink
                  href={item.href}
                  onClick={item.onClick}
                  exact={item.exact}
                  scrollIntoView={true}
                >
                  <div className={styles['tabs__element']}>{item.label}</div>
                </ActiveLink>
              </li>
            );
          })}
        </ul>
      </Scroller>
    </div>
  );
};

Tabs.displayName = 'Tabs';

export default Tabs;
